import React from 'react';
import {SalesforceUserSelector} from 'components/Prospect/SalesforceUserSelector';
import {useUpdateSalesforceLeadOwnerMutation, SalesforceLead} from 'api';

interface Props {
  salesforceLead: SalesforceLead;
}

export default ({salesforceLead}: Props) => {
  const [updateOwner] = useUpdateSalesforceLeadOwnerMutation({});
  return (
    <div className="flex gap-2 items-center">
      <div className="text-c-light text-xm mr-2">所有者</div>
      <div>
        <SalesforceUserSelector
          salesforceUser={salesforceLead?.salesforceOwner}
          onChange={(value) => {
            updateOwner({
              variables: {
                id: salesforceLead?.id,
                salesforceUserIdString: value,
              },
            });
          }}
        />
      </div>
    </div>
  );
};
